import axios from 'axios';

import { getApiEndPoint } from '../../../helpers/apibase';
import { mapServerError } from '../../../services/utils/serverErrorMapper';

const privateApi = axios.create({
  baseURL: getApiEndPoint(),
  withCredentials: true,
});

export const privateSupportEmailQueryKey = 'privateSupportEmailAddress';

const privateSupportEmailUrl = (appId: string) =>
  `/privateapi/v1.0/apps/${appId}/privatesupportemailaddress`;

export const getPrivateSupportEmail = async (appId: string): Promise<string> => {
  try {
    const response = await privateApi.get(privateSupportEmailUrl(appId));
    return response.data.Data?.PrivateSupportEmailAddress ?? '';
  } catch (error) {
    throw await mapServerError(error);
  }
};

export const setPrivateSupportEmail = async (appId: string, email: string): Promise<void> => {
  try {
    await privateApi.post(privateSupportEmailUrl(appId), { PrivateSupportEmailAddress: email });
  } catch (error) {
    throw await mapServerError(error);
  }
};
